import { useState, useContext, useRef } from "react";
import { AuthContext } from "../context/AuthContext";
import "../styles/modal.css";

function TransactionPinModal({ onClose }) {
  const [step, setStep] = useState(1);
  const [newPin, setNewPin] = useState(["", "", "", ""]);
  const [confirmPin, setConfirmPin] = useState(["", "", "", ""]);
  const [showPin, setShowPin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { setTransactionPin } = useContext(AuthContext);

  const newPinRefs = useRef([]);
  const confirmPinRefs = useRef([]);

  const handlePinInput = (index, value, setter, current, refs) => {
    if (!/^\d?$/.test(value)) return;
    const updated = [...current];
    updated[index] = value;
    setter(updated);
    if (value && index < 3) {
      refs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index, setter, current, refs) => {
    if (e.key === "Backspace" && !current[index] && index > 0) {
      refs.current[index - 1]?.focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    const pinStr = newPin.join("");
    const confirmStr = confirmPin.join("");

    if (pinStr.length !== 4 || confirmStr.length !== 4) {
      return setError("All PIN boxes must be filled.");
    }

    if (pinStr !== confirmStr) {
      return setError("PINs do not match.");
    }

    setLoading(true);
    const res = await setTransactionPin(pinStr);
    setLoading(false);

    if (res.success) {
      setSuccess("PIN set successfully!");
      setTimeout(() => {
        onClose();
      }, 1000);
    } else {
      setError(res.error || "Failed to set PIN");
    }
  };

  return (
    <div className="overlay">
      {step === 1 && (
        <div className="modal-card intro-modal">
          <div className="pin-preview">* * * *</div>
          <h2>You are yet to create a transaction PIN for this business</h2>
          <p>
            To secure your transactions, you will require a 4-digit transaction
            PIN to validate every transaction.
          </p>
          <button className="primary-button" onClick={() => setStep(2)}>
            Create PIN
          </button>
        </div>
      )}

      {step === 2 && (
        <div className="modal-card form-modal">
          <h3>Create Transaction PIN</h3>
          <form onSubmit={handleSubmit}>
            <label>New PIN</label>
            <div className="verify-otp-container">
              {newPin.map((digit, index) => (
                <input
                  key={index}
                  type={showPin ? "tel" : "password"}
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength="1"
                  value={digit}
                  onChange={(e) =>
                    handlePinInput(index, e.target.value, setNewPin, newPin, newPinRefs)
                  }
                  onKeyDown={(e) =>
                    handleKeyDown(e, index, setNewPin, newPin, newPinRefs)
                  }
                  ref={(el) => (newPinRefs.current[index] = el)}
                />
              ))}
            </div>

            <label>Confirm New PIN</label>
            <div className="verify-otp-container">
              {confirmPin.map((digit, index) => (
                <input
                  key={index}
                  type={showPin ? "tel" : "password"}
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength="1"
                  value={digit}
                  onChange={(e) =>
                    handlePinInput(index, e.target.value, setConfirmPin, confirmPin, confirmPinRefs)
                  }
                  onKeyDown={(e) =>
                    handleKeyDown(e, index, setConfirmPin, confirmPin, confirmPinRefs)
                  }
                  ref={(el) => (confirmPinRefs.current[index] = el)}
                />
              ))}
            </div>

            {error && <div className="error-text">{error}</div>}
            {success && <div className="bulk-success">{success}</div>}

            <button type="submit" className="primary-button" disabled={loading}>
              {loading ? (
                <div className="spinner small-spinner" /> // Add spinner in your CSS
              ) : (
                "Set PIN"
              )}
            </button>
          </form>
        </div>
      )}
    </div>
  );
}

export default TransactionPinModal;
